import cloneDeep from "lodash.clonedeep";

/* 
* Dijkstra's algorithm for pathfinding
*/
const findPath = graph => {
  graph.startingPoint.distance = 0;

  let queue = [];
  queue.push(graph.startingPoint);

  const findPathNodes = function (queue, pathNodes = {}, iterations = 0) {
    if (queue.length < 1) {
      return null;
    }

    const currentNode = queue.shift();
    const currentDistance = currentNode.distance;

    if (currentNode.id === graph.endPoint.id) {
      pathNodes[currentNode.id] = currentNode;
      return pathNodes;
    }

    // explore all connections
    currentNode.connections.forEach(connection => {
      // skip already visited nodes
      if (pathNodes[connection.id]) {
        return;
      }

      const connectionObj = graph.nodes[connection.id];

      const newQueueItem = {
        id: connection.id,
        pathVia: currentNode.id,
        distance: currentDistance + connection.distance,
        connections: connectionObj.connections,
        $collection: connectionObj.$collection,
      };

      const matchInQueueIndex = queue.findIndex(item => {
        return item.id === newQueueItem.id;
      });

      if (matchInQueueIndex !== -1) {
        if (queue[matchInQueueIndex].distance > newQueueItem.distance) {
          queue.splice(matchInQueueIndex, 1);
          queue.push(newQueueItem);
        }
      } else {
        queue.push(newQueueItem);
      }
    });

    pathNodes[currentNode.id] = currentNode;

    queue.sort((a, b) => a.distance - b.distance);

    iterations++;
    if (iterations > 200) {
      return null;
    }

    return findPathNodes(queue, pathNodes, iterations);
  };


  const pathNodes = findPathNodes(cloneDeep(queue));

  if (!pathNodes) {
    return null;
  }

  const constructFinalPath = function (pathNodes, currentNode, finalPath = []) {
    finalPath.push(currentNode);
    if (currentNode.id === graph.startingPoint.id) {
      return finalPath.reverse();
    } else {
      return constructFinalPath(pathNodes, pathNodes[currentNode.pathVia], finalPath);
    }
  };

  const finalPath = constructFinalPath(pathNodes, pathNodes[graph.endPoint.id]);
  return {
    nodes: finalPath,
    totalDistance: finalPath[finalPath.length - 1].distance, // total path distance is equal to the last item's distance  
  };
};


export default findPath;